<template>
  <div class="material">
    <div v-if="block.format == 'Image'" class="preview">
      <img v-if="block.image != null" :src="block.image.url" />
    </div>
    <div v-if="block.format == 'Audio'" class="preview">
      <audio controls>
        <source :src="block.audio.url">
      </audio>
    </div>
    <div v-if="block.format == 'Embed' && block.embed.style != 'Loom' && block.embed.style != 'PDF' && block.embed.style != 'YouTube' && block.embed.style != '3D'" class="preview">
      <!--<iframe :class="[isMedium]" :src="block.embed.url"></iframe>-->
      <!--<a :href="block.embed.url" :class="[hideExpanded]" target="_blank">View Embed URL</a>-->
      <a :href="block.embed.url" target="_blank">Open in new tab</a>
    </div>

    <div v-if="block.format == 'Embed' && block.embed.style == 'Loom'" class="preview">
      <div v-if="expanded" v-html="loomHtml" class="loomEmbed" />
      <img v-if="!expanded && loomThumbnail != null" :src="loomThumbnail" />
    </div>

    <div v-if="block.format == 'Embed' && block.embed.style == 'PDF'" class="preview">
      <iframe :src="block.embed.url + '#zoom=FitH'" :class="['pdf-embed', 'pdf-embed--is-iframe', isExpanded]" ></iframe>
      <!-- <div :id="pdfViewerId" :class="['pdfViewer', isExpanded]"></div> -->
      <iframe :src="'https://drive.google.com/viewerng/viewer?embedded=true&url=' + block.embed.url" :class="['pdf-embed', 'pdf-embed--is-gdrive', isExpanded]" ></iframe>
      <!-- <embed src="http://example.com/the.pdf" width="500" height="375"> -->
    </div>

    <div v-if="block.format == 'Embed' && block.embed.style == 'YouTube'" :class="['preview', 'preview--is-youtube']">
      <div v-if="expanded" v-html="youtubeHtml" class="loomEmbed" />
      <img v-if="!expanded && youtubeThumbnail != null" :src="youtubeThumbnail" />
    </div>

    <div v-if="block.format == 'Embed' && block.embed.style == '3D'" class="preview preview--is-3D">
      <Material3D :objectUrl="this.block.embed.url"></Material3D>
    </div>

    <div v-if="block.format == 'Hyperlink'" :class="['hyperlink-block', isExpanded]">
      <!--<iframe :src="block.hyperlink.url"></iframe>-->
      <!--<p><a :href="block.hyperlink.url" :class="[hideExpanded]" target="_blank">{{ block.hyperlink.url }}</a></p>-->

      <div class="preview">
        <p v-if="block.hyperlink.previewStatus == 'fetching'" class="hyperlink-note">Capturing...</p>

        <a v-if="block.hyperlink.previewStatus == 'done' && this.expanded" :href="block.hyperlink.url" target="_blank" :title="block.hyperlink.url"><img :src="block.hyperlink.previewImg" /></a>
        <img v-if="block.hyperlink.previewStatus == 'done' && !this.expanded" :src="block.hyperlink.previewImg" />

        <p v-if="block.hyperlink.previewStatus == 'error'" class="hyperlink-note">
          No Preview
        </p>
      </div>
      <div class="hyperlink-link" :title="block.hyperlink.url">
        <a :href="block.hyperlink.url" target="_blank">{{ shortHyperlink }}</a>
      </div>
      <!-- <p v-if="!block.hyperlink.previewStatus"><a :href="block.hyperlink.url" target="_blank">{{ block.hyperlink.url }}</a></p> -->
    </div>
    <div v-if="block.format == 'Video'" class="preview">
      <video :controls="(isMedium || isSmall) ? null : 'controls'" :autoplay="(isMedium || isSmall) ? 'autoplay' : null" :muted="(isMedium || isSmall) ? 'muted' : null" :loop="(isMedium || isSmall) ? 'loop' : null">
        <source :src="block.video.url">
      </video>
    </div>
    <p v-if="block.format == 'Text'" v-html="block.text">
    </p>
  </div>
</template>

<script>

import { oembed } from "@loomhq/loom-embed";
import Material3D from '@trust/components/Material3D';

// import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.js";
// import * as PDFJSViewer from "pdfjs-dist/legacy/web/pdf_viewer";
// import "pdfjs-dist/web/pdf_viewer.css";
// pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/build/pdf.worker.min.js";

export default {
  name: 'BlockMaterial',
  components: {
    Material3D,
  },
  data() {
    return {
      loomHtml: null,
      loomThumbnail: null,
      youtubeHtml: null,
      youtubeThumbnail: null,
    }
  },
  props: ['block', 'expanded', 'medium', 'small'],
  computed: {
    showExpanded(){
      return (this.expanded ? '' : '');
    },
    hideExpanded(){
      return (this.expanded ? 'hidden' : '');
    },
    isSmall(){
      return (this.small ? true : false);
    },
    isMedium(){
      return (this.medium ? true : false);
    },
    // Not in use atm:
    // isMediumClass(){
    //   return (this.medium ? 'is--medium' : '');
    // },
    isExpanded(){
      return (this.expanded ? 'is--expanded' : '');
    },
    shortHyperlink(){
      let url = this.block.hyperlink.url;
      if(url.includes('http://')){
        url = url.replace('http://', '')
      } else if(url.includes('https://')){
        url = url.replace('https://', '')
      }

      if(url.includes('www.')){
        url = url.replace('www.', '')
      }

      if(url.slice(-1) == ' '){
        url = url.slice(0, -1);
      }

      if(url.slice(-1) == '/'){
        url = url.slice(0, -1);
      }

      return url;
    },
    // pdfViewerId(){
    //   return 'pdf-viewer-' + this.block.id;
    // }
  },
  methods: {
    async loadLoom() {
      const { html, thumbnail_url } = await oembed(this.block.embed.url, { width: 400, gifThumbnail: true });
      this.loomHtml = html;
      this.loomThumbnail = thumbnail_url;
    },
    async loadYoutube(){
      let fetchUrl = 'https://www.youtube.com/oembed?url=' + this.block.embed.url + '&format=json';
      let response = await fetch(fetchUrl);
      let { html, thumbnail_url } = await response.json();
      console.log('youtube: ', html, thumbnail_url)
      this.youtubeHtml = html;
      this.youtubeThumbnail = thumbnail_url;
    },
    // async loadPDF(){
    //   let container = document.querySelector('#' + this.pdfViewerId);
    //   console.log(container)
    //   console.log(PDFJSViewer)
    //   console.log(PDFJSViewer.PDFViewer)
    //   let pdfViewer = new PDFJSViewer.PDFViewer({
    //     container: container
    //   });
    //   let loadingTask = pdfjsLib.getDocument(this.block.embed.url);
    //   let pdf = await loadingTask.promise;
    //   pdfViewer.setDocument(pdf);
    // }
  },
  mounted () {

    if(this.block.format == 'Embed' && this.block.embed.style == 'Loom'){
      this.loadLoom();
    }

    if(this.block.format == 'Embed' && this.block.embed.style == 'YouTube'){
      this.loadYoutube();
    }

    // if(this.block.format == 'Embed' && this.block.embed.style == 'PDF'){
    //   this.loadPDF();
    // }

    // Start checking for updated hyperlink preview
    if(this.block.format == 'Hyperlink' && this.block.hyperlink.previewStatus == 'fetching'){
      let previewStatusTimer = setInterval (() => {
        if(this.block.hyperlink.previewStatus == 'fetching'){
          this.$store.dispatch('fetchBlock', this.block);
        } else {
          clearInterval(previewStatusTimer);
        }
      }, 1500);
    }
  }
}
</script>

<style>

  .material {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .material img {
    object-fit: contain;
    display: block;
    width: fit-content;
    height: fit-content;
    max-height: 100%;
    max-width: 100%;
    /* min-height: 120px; */
  }

  .material video {
    width: 100%;
    height: auto;
    display: flex;
    max-height: 100%;
    max-width: 100%;
  }

  .material p {
    background: var(--beige-200);
    padding: 15px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
  }

  .material .hidden {
    display: none;
  }

  .material .embedContainer {
    min-height: 300px;
    min-width: 300px;
  }

  .material .hyperlink-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .material .hyperlink-block .hyperlink-note {
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--beige-700);
    background: var(--beige-400);
  }

  .material .hyperlink-block .preview {
    padding: 10px;
    box-sizing: border-box;
    height: calc(100% - 30px);
  }

  .material .hyperlink-block .preview img {
    border-radius: 2px;
    box-shadow: 0px 4px 10px var(--beige-700);
    transition: var(--transition-snappy);
  }

  .material .hyperlink-block.is--expanded .preview img:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 20px var(--beige-700);
  }

  .material .hyperlink-block .hyperlink-link {
    font-size: 0.9rem;
    padding: 0px 10px 5px 10px;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    width: 220px;
    max-width: 20vw;
    height: 1rem;
    color: var(--beige-700);
  }

  .block.small .box .material .hyperlink-block .hyperlink-link {
    height: 1.5rem;
  }

  .material .hyperlink-block .hyperlink-link a {
    text-decoration: none;
    color: var(--beige-700);
    text-align: center;
  }

  .material .hyperlink-block .hyperlink-link a:hover {
    color: var(--beige-1000);
    text-decoration: underline;
  }

  .material .hyperlink-block .preview a {
    height: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .material .preview.preview--is-youtube {
    padding: 10px;
    box-sizing: border-box;
  }

  .material .preview.preview--is-youtube img {
    border-radius: 2px;
    box-shadow: 0px 4px 10px var(--beige-700);
  }


  .material .preview {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .material .preview .imgContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .material .preview .imgContainer a {
    height: fit-content;
    width: fit-content;
  }

  .material .preview .div {
    height: 100%;
    width: 100%;
  }

  .material iframe {
    width: 100%;
    height: 100%;
    padding-bottom: 8px;
  }

  .medium .material iframe {
    height: 70%;
  }

  .medium .material video {
    pointer-events: none;
  }

  .preview.preview--is-3D {

  }

  .preview.preview--is-3D .container3D {
    width: 100%;
    height: 100%;
  }

  .loomEmbed {
    height: 100%;
    width: 100%;
  }

  .pdf-embed {
    pointer-events: none;
    border: none;
  }

  .pdf-embed.is--expanded {
    pointer-events: all;
  }

  .pdf-embed.pdf-embed--is-iframe {
    display: block;
  }

  .pdf-embed.pdf-embed--is-gdrive {
    display: none;
  }


  @media (max-device-width: 600px) {
    .material .hyperlink-block .hyperlink-link {
      max-width: 55vw;
    }

    .material .hyperlink-block .preview img {
      width: auto;
      height: auto;
    }

    .pdf-embed.pdf-embed--is-iframe {
      display: none;
    }

    .pdf-embed.pdf-embed--is-gdrive {
      display: block;
    }
  }

</style>
